import React from "react";
import OptionBarServiceButton from "./OptionBarServiceButton";

const RenderNestedServices = ({ options, isOpen, icon }) => {
  return (
    <ul className={isOpen ? "list-is-open" : "list-is-closed"}>
      {options &&
        options.map((option) => (
          <OptionBarServiceButton
            option={option}
            icon={icon}
            forms={option.forms}
            key={option.serviceId}
          />
        ))}
    </ul>
  );
};

export default RenderNestedServices;
